import React from "react";
import Seo from "../components/Seo";
import { Section, PageHero, FeatureCard } from "../components/primitives";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import CTABanner from "../components/CTABanner";
import { CORE_FEATURES } from "../lib/content";
import * as Icons from "lucide-react";

export default function Features() {
  return (
    <div>
      <Seo
        title="Features"
        path="/features"
        description="Explore the Jollof Fit Kingdom platform — personalized coaching, workout tracking, nutrition, body composition, Kingdom Score, Kingdom Insights, progress photos and connected health synchronization."
        noindex
      />
      <PageHero
        eyebrow="The Platform"
        title="One complete"
        highlight="fitness ecosystem"
        description="Every capability of Jollof Fit Kingdom is designed to work together — turning your data into a single, clear view of your health and performance."
      />

      <Section className="mt-4">
        <Stagger className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {CORE_FEATURES.map((f) => {
            const Icon = Icons[f.icon] || Icons.Sparkles;
            const linkable = ["coaching", "workout-tracking", "nutrition", "smart-scale", "kingdom-score", "kingdom-insights"].includes(
              f.slug
            );
            return (
              <StaggerItem key={f.title}>
                <FeatureCard
                  icon={Icon}
                  title={f.title}
                  desc={f.desc}
                  to={linkable ? `/${f.slug}` : undefined}
                  testid={`feature-${f.title.toLowerCase().replace(/\s+/g, "-")}`}
                />
              </StaggerItem>
            );
          })}
        </Stagger>
      </Section>

      {/* Kingdom Membership */}
      <Section className="mt-28">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border border-gold/25 bg-gradient-to-b from-[#14110a] to-[#080808] p-8 md:p-12">
            <div className="pointer-events-none absolute -top-24 left-1/2 h-56 w-56 -translate-x-1/2 rounded-full bg-gold/10 blur-3xl" />
            <div className="relative grid gap-10 lg:grid-cols-2 lg:items-center">
              <div>
                <span className="inline-flex items-center gap-2 rounded-full border border-gold/30 bg-gold/10 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-gold">
                  <Icons.Crown className="h-3.5 w-3.5" /> Kingdom Membership
                </span>
                <h2 className="mt-5 font-heading text-3xl font-medium tracking-tight text-white md:text-4xl">
                  Unlock the full Kingdom
                </h2>
                <p className="mt-5 text-base leading-relaxed text-zinc-400">
                  Kingdom membership unlocks the advanced features of the Jollof Fit Kingdom mobile app. Start with a
                  3-day free trial, then continue on a monthly subscription. Purchases are made in the app through the
                  Apple App Store or Google Play, and you can manage or cancel anytime in your store subscription
                  settings.
                </p>
                <p className="mt-4 text-xs text-zinc-500">
                  Trial terms, pricing and currency are shown at purchase in the app store.
                </p>
              </div>
              <Stagger className="grid gap-3 sm:grid-cols-2">
                {[
                  "Premium personalized coaching",
                  "Advanced nutrition & meal planning",
                  "Full Kingdom Insights",
                  "Progress photos & body tracking",
                  "Deeper training analytics",
                  "Reminders & notifications",
                ].map((b) => (
                  <StaggerItem key={b}>
                    <div className="flex items-center gap-3 rounded-2xl border border-white/10 bg-[#0a0a0a] p-4">
                      <Icons.Check className="h-4 w-4 shrink-0 text-gold" />
                      <span className="text-sm text-zinc-300">{b}</span>
                    </div>
                  </StaggerItem>
                ))}
              </Stagger>
            </div>
          </div>
        </Reveal>
      </Section>

      <CTABanner />
    </div>
  );
}
